/* eslint-disable */
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment'
import {Customer} from './customer.model';
import {APIResponseWrapper} from '../models/common/api-response-wrapper';
import {Role} from "./customer-role.model";
import {AuthService} from "../security/auth.service";

@Injectable({
    providedIn: 'root'
})
export class CustomerService {

    restApiUrl: string

    constructor(private http: HttpClient, private authService: AuthService) {
        this.restApiUrl = `${environment.restApiUrl}`;
    }

    getCustomerByFirebaseId(firebaseId: string) {
        return this.http.get<APIResponseWrapper<Customer>>(`${this.restApiUrl}customer-endpoint/customer?customerId=${firebaseId}`);
    }

    getCustomerById(customerId: number) {
        return this.http.get<APIResponseWrapper<Customer>>(`${this.restApiUrl}customer-endpoint/customer?id=${customerId}`);
    }

    getCustomerByMobileNumber(phoneNumber: string) {
        return this.http.get<APIResponseWrapper<Customer>>(`${this.restApiUrl}customer-endpoint/customer?phoneNumber=${phoneNumber.replace('+','%2B')}`);
    }

    getCustomerByEmailAddress(emailAddress: string) {
        return this.http.get<APIResponseWrapper<Customer>>(`${this.restApiUrl}customer-endpoint/customer?emailAddress=${encodeURIComponent(emailAddress)}`);
    }

    createCustomer(customer: Customer) {
        return this.http.post<APIResponseWrapper<Customer>>(`${this.restApiUrl}customer-endpoint/customer`, customer)
    }

    createCustomerContact(customer: Customer) {
        return this.http.post<APIResponseWrapper<Customer>>(`${this.restApiUrl}customer-endpoint/customer/contact`, customer);
    }

    updateCustomer(customer: Customer) {
        return this.http.put<APIResponseWrapper<Customer>>(`${this.restApiUrl}customer-endpoint/customer`, customer)
    }

    resolveIdentityCollisionDelete(request: { targetCustomerId?: number; conflictingCustomerId?: number; conflictingFirebaseId?: string | null }) {
        return this.http.post<APIResponseWrapper<unknown>>(
            `${this.restApiUrl}customer-endpoint/identity-collision/resolve-delete`,
            request
        );
    }

    getCustomersByCompany(companyId: number, refresh: boolean = false) {
        const params: Record<string, string> = { companyId: companyId.toString() };
        if (refresh) {
            params['_'] = Date.now().toString();
        }
        return this.http.get<Customer[]>(`${this.restApiUrl}customer-endpoint/customers-by-company`, { params });
    }

    searchCustomers(searchText: string, page: number = 0, pageSize: number = 20) {
        const params: Record<string, string> = {
            searchText: searchText,
            page: page.toString(),
            pageSize: pageSize.toString()
        };
        return this.http.get<Customer[]>(`${this.restApiUrl}customer-endpoint/customers`, { params });
    }

    getAllRoles(roleScope?: string) {
        const options = roleScope ? { params: { roleScope } } : {};
        return this.http.get<Role[]>(`${this.restApiUrl}customer-endpoint/roles`, options);
    }

    getRolesByCustomerId(customerId: number) {
        return this.http.get<Role[]>(`${this.restApiUrl}customer-endpoint/${customerId}/roles`);
    }

    addRoleToCustomer(customerId: number, role: Role) {
        return this.http.post<Role>(`${this.restApiUrl}customer-endpoint/${customerId}/roles`, role);
    }

    deleteRoleFromCustomer(customerId: number, roleId: number) {
        return this.http.delete<void>(`${this.restApiUrl}customer-endpoint/${customerId}/roles/${roleId}`);
    }

    modifyRoleForCustomer(customerId: number, roleId: number, role: Role) {
        return this.http.put<Role>(`${this.restApiUrl}customer-endpoint/${customerId}/roles/${roleId}`, role);
    }

    modifyRolesForCustomer(customerId: number, roles: Role[]) {
        return this.http.put<Role[]>(`${this.restApiUrl}customer-endpoint/${customerId}/roles`, roles);
    }


}
